interface ProviderRpcError extends Error {
  message: string
  code: number
  data?: unknown
}

interface ProviderEventMap {
  accountsChanged: string[]
  chainChanged: string
  disconnect: ProviderRpcError
  connect: { chainId: string }
  networkChanged: string
}

type EventHandler<T = unknown> = (...args: T[]) => void

export class EventEmitter<T extends Record<string, any> = ProviderEventMap> {
  private events: { [K in keyof T]?: EventHandler<T[K]>[] } = {}

  protected emit<K extends keyof T>(event: K, ...args: T[K][]): void {
    const handlers = this.events[event]
    if (handlers) {
      handlers.forEach((handler) => handler(...args))
    }
  }

  public on<K extends keyof T>(event: K, handler: EventHandler<T[K]>): void {
    if (!this.events[event]) {
      this.events[event] = []
    }
    this.events[event]?.push(handler)
  }

  public removeListener<K extends keyof T>(event: K, handler: EventHandler<T[K]>): void {
    const handlers = this.events[event]
    if (handlers) {
      this.events[event] = handlers.filter((h) => h !== handler)
    }
  }
}
